<h2 mat-dialog-title>
  <svg class="icon-24" aria-hidden="false">
    <use href="assets/images/ok-icons-sprite.svg#building-s"></use>
  </svg>
  Flyt organisation
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<form [formGroup]="form">
  <mat-dialog-content>
    <div class="form-row">
      <adm-org-typeahead
        [initialId]="undefined"
        [resetTrigger]="resetOrgTrigger()"
        (itemSelected)="organizationSelected($event)"
        (clearTypeAhead)="resetOrganization()" />
    </div>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Vælg afdeling</mat-label>
        <mat-select formControlName="departmentId" okCustomDropDownArrowDirective>
          @for (department of departments$ | async; track department.id) {
            <mat-option [value]="department.id">{{ department.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix" [class.field-disabled]="!(accessGroups$ | async)?.length">
        <mat-label>Vælg adgangsgrupper</mat-label>
        <mat-select
          [disabled]="!(accessGroups$ | async)?.length"
          [formControl]="form.controls.selectedAccessGroups"
          multiple
          okCustomDropDownArrowDirective>
          <mat-select-trigger>
            {{ form.controls.selectedAccessGroups.value[0]?.name || '' }}
            @if (form.controls.selectedAccessGroups.value.length > 1) {
              <span class="example-additional-selection">
                (+{{ form.controls.selectedAccessGroups.value.length - 1 }}
                {{ form.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
              </span>
            }
          </mat-select-trigger>
          @for (accessGroup of accessGroups$ | async; track accessGroup) {
            <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <ok-feedback-info>
        Flytning af brugers organisation, vil medføre sletning af den eksisterende og oprettelse af en ny bruger. Dette flytter også brikker
        for brugeren, men deres tidligere forbrug flyttes ikke med.
      </ok-feedback-info>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
    <button
      class="actions__button margin--right-2"
      type="button"
      [disabled]="!form || !form.valid"
      (click)="submit()"
      mat-raised-button
      color="primary">
      Gem
    </button>
  </mat-dialog-actions>
</form>
